import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@cc/store'
import initValidation from '@common/bootstrap/validation'

Vue.use(VueI18n)

const locale = store.state.locale
const eventLocale = store.state.eventLocale

let messages = {
  [locale]: require('@plat/lang/' + locale).default
}

if (locale !== eventLocale) {
  messages[eventLocale] = require('@plat/lang/' + eventLocale).default
}

export default new VueI18n({
  locale,
  fallbackLocale: 'en_GB',
  messages
})

initValidation(store)
